import { RemoteGetAllCoursesUser } from 'data/usecases/courses';
import { GetAllCoursesByUserUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCoursesUser } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllCoursesUser = (): GetAllCoursesByUserUseCaseInterface =>
  new RemoteGetAllCoursesUser(makeApiUrlCoursesUser(), makeAxiosHttpClient());
